<template>
  <Layout style="height: 100%" class="main">
    <Layout>
      <Header class="header-con">
        <Row class="header-row">
          <Col span="6" class="header-row-left">
            <img :src="minLogo" key="min-logo" class="min-logo"/>
            <span class="logo-title">{{systemTitle}}</span>
          </Col>
          <Col span="10">&nbsp;</Col>
          <Col span="8">
            <user :message-unread-count="unreadCount" :showMessage="false" :showUserInfo="false" :user-avatar="userAvatar" style="float: right; margin-right: 20px;"/>
            <div class="vip-change" @click="handleVipChange">
              <img src="/static/brand/bg/bg-vip-1.png">
              <span>更换专业版</span>
            </div>
          </Col>
        </Row>
      </Header>
      <Content class="main-content-con">
        <router-view/>
        <ABackTop :height="100" :bottom="80" :right="50" container=".content-wrapper"></ABackTop>
      </Content>
    </Layout>
  </Layout>
</template>

<script>
import User from './components/user'
import ABackTop from './components/a-back-top'
import minLogo from '@/assets/images/logo-mini.png'
import './main.less'
export default {
  name: 'mainSimplicity',
  components: {
    User,
    ABackTop
  },
  computed: {
    systemTitle () {
      return this.$config.title
    },
    userAvatar () {
      return this.$store.state.user.avatarImgPath
    },
    unreadCount () {
      return this.$store.state.user.unreadCount
    }
  },
  data () {
    return {
      minLogo
    }
  },
  methods: {
    handleVipChange () {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>
<style lang="less" scoped="scoped">
  .header-con {
    background: #17233d;
  }
  .header-row {
    .min-logo {
      margin-top: 7px;
      height: 50px;
    }
    .logo-title {
      color: #FFFFFF;
      margin-left: 10px;
      font-size: 24px;
      position: relative;
      top: -18px
    }
    /deep/ .ivu-icon-md-arrow-dropdown {
      color: #FFFFFF;
    }
    .vip-change {
      margin: 15px 40px 0 0;
      text-align: center;
      float: right;
      width: 130px;
      height: 35px;
      line-height: 35px;
      background-color: #F5A623;
      color: #FFFFFF;
      border-radius: 40px;
      cursor: pointer;
      img {
        position: relative;
        top: 2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/main-simplicity.vue